export const EXPERIENCE_NAME_PREFIX = 'embedded-confluence/';
export let ExperienceNames = /*#__PURE__*/function (ExperienceNames) {
  ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
  ExperienceNames["CC_VIEW_PAGE"] = "view-page";
  ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
  ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
  ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
  ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
  ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
  ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
  ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
  return ExperienceNames;
}({});
export let ExperienceReasons = /*#__PURE__*/function (ExperienceReasons) {
  ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
  ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
  ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
  ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
  return ExperienceReasons;
}({});